import { render, staticRenderFns } from "./day-bj.vue?vue&type=template&id=f2c327e2&scoped=true&"
import script from "./day-bj.vue?vue&type=script&lang=js&"
export * from "./day-bj.vue?vue&type=script&lang=js&"
import style0 from "./day-bj.vue?vue&type=style&index=0&id=f2c327e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c327e2",
  null
  
)

export default component.exports